export const append = (testId?: string, suffix?: number | string) =>
  testId ? (suffix ? `${testId}-${suffix}` : testId) : undefined;
